import styled from '@emotion/styled';
import { themeColorPicker, themeValue } from "../../../utils/themeSelectors";

export const StyledCard = styled.div`
  box-shadow: ${themeValue('shadows')('card')};
  background: ${themeColorPicker('white01')};
  border-radius: ${themeValue('radii')('md')};
  padding: ${({ noPadding } : { noPadding: boolean }) => noPadding && '0rem' || '2rem'};
`;
